import {
  FaRocket,
  FaBolt,
  FaGem,
  FaShieldAlt,
  FaCheckCircle,
  FaInfinity,
  FaCrown,
  FaBusinessTime,
  FaChartLine,
  FaDatabase,
  FaClock,
} from "react-icons/fa";

export const plans = [
  {
    name: "Free",
    backendName: "FREE",
    subtitle: "Free Forever",
    displayName: "Free Plan",
    pricing: {
      USD: {
        monthly: 0,
        yearly: 0,
      },
      INR: {
        monthly: 0,
        yearly: 0,
      },
    },
    update: "60 seconds",
    icon: FaRocket,
    color: "success",
    gradient: "linear-gradient(135deg, #28a745 0%, #20c997 100%)",
    cashfree_plan_id: {
      USD: {
        monthly: null,
        yearly: null,
      },
      INR: {
        monthly: null,
        yearly: null,
      },
    },
    features: [
      { text: "100 API Requests for a month", icon: FaRocket },
      { text: "Updates Every 60 Seconds", icon: FaClock },
      { text: "Basic Currency Pairs", icon: FaCheckCircle },
      { text: "One Month Only", icon: FaClock },
    ],
    limitations: [
      { text: "No Technical Indicators", icon: FaChartLine },
      { text: "No Historical Data", icon: FaDatabase },
      { text: "No Real-time Updates", icon: FaBolt },
    ],
    highlight: false,
    unlimited: false,
    popular: false,
    apiLimit: 100,
    duration: "1 month only",
    isFree: true,
  },
  {
    name: "Basic",
    backendName: "BASIC",
    subtitle: "Perfect for small businesses",
    displayName: "Basic Plan",
    pricing: {
      USD: {
        monthly: 10,
        yearly: 108,
      },
      INR: {
        monthly: 849,
        yearly: 9180,
      },
    },
    update: "60 seconds",
    icon: FaBusinessTime,
    color: "primary",
    gradient: "linear-gradient(135deg, #007bff 0%, #0056b3 100%)",
    cashfree_plan_id: {
      USD: {
        monthly: "ibr_basic_usd_m",
        yearly: "ibr_basic_usd_y",
      },
      INR: {
        monthly: "ibr_basic_inr_m_gst",
        yearly: "ibr_basic_inr_y_gst",
      },
    },
    features: [
      { text: "From 35,000 API Requests/month (configurable)", icon: FaRocket },
      { text: "Updates Every 60 Seconds", icon: FaClock },
      { text: "All Currency Pairs", icon: FaGem },
      { text: "Monthly/Yearly Billing", icon: FaCheckCircle },
    ],
    limitations: [
      { text: "No Technical Indicators", icon: FaChartLine },
      { text: "No Historical Data", icon: FaDatabase },
      { text: "No Real-time Updates", icon: FaBolt },
    ],
    highlight: false,
    unlimited: false,
    popular: false,
    apiLimit: 35000,
  },
  {
    name: "Essential",
    backendName: "ESSENTIAL",
    subtitle: "Growing businesses with real-time needs",
    displayName: "Essential Plan",
    pricing: {
      USD: {
        monthly: 35,
        yearly: 378,
      },
      INR: {
        monthly: 2999,
        yearly: 32388,
      },
    },
    update: "60 seconds",
    icon: FaChartLine,
    color: "info",
    gradient: "linear-gradient(135deg, #17a2b8 0%, #138496 100%)",
    cashfree_plan_id: {
      USD: {
        monthly: "ibr_essential_usd_m",
        yearly: "ibr_essential_usd_y",
      },
      INR: {
        monthly: "ibr_essential_inr_m_gst",
        yearly: "ibr_essential_inr_y_gst",
      },
    },
    features: [
      { text: "From 15,00,000 API Requests/month (configurable)", icon: FaRocket },
      { text: "Updates Every 60 Seconds", icon: FaClock },
      { text: "All Currency Pairs", icon: FaGem },
      { text: "Historical Data Access", icon: FaDatabase },
      { text: "All APIs (except Technical)", icon: FaCheckCircle },
    ],
    limitations: [{ text: "No Technical Indicators", icon: FaChartLine }],
    highlight: false,
    unlimited: false,
    popular: true,
    apiLimit: 1500000,
  },
  {
    name: "Pro",
    backendName: "PRO",
    subtitle: "High-volume trading operations",
    displayName: "Pro Plan",
    pricing: {
      USD: {
        monthly: 99,
        yearly: 1069,
      },
      INR: {
        monthly: 8499,
        yearly: 91788,
      },
    },
    update: "5 seconds",
    icon: FaShieldAlt,
    color: "warning",
    gradient: "linear-gradient(135deg, #ffc107 0%, #e0a800 100%)",
    cashfree_plan_id: {
      USD: {
        monthly: "ibr_pro_usd_m",
        yearly: "ibr_pro_usd_y",
      },
      INR: {
        monthly: "ibr_pro_inr_m_gst",
        yearly: "ibr_pro_inr_y_gst",
      },
    },
    features: [
      { text: "From 35,00,000 API Requests/month (configurable)", icon: FaInfinity },
      { text: "Real-time Updates ", icon: FaBolt },
      { text: "All Currency Pairs", icon: FaGem },
      { text: "Historical Data Access", icon: FaDatabase },
      { text: "All APIs (except Technical)", icon: FaCheckCircle },
      { text: "High Volume Support", icon: FaRocket },
    ],
    limitations: [{ text: "No Technical Indicators", icon: FaChartLine }],
    highlight: true,
    unlimited: false,
    popular: false,
    apiLimit: 3500000,
  },
  {
    name: "Ultimate",
    backendName: "ULTIMATE",
    subtitle: "Enterprise solution with all features",
    displayName: "Ultimate Plan",
    pricing: {
      USD: {
        monthly: 294,
        yearly: 3175,
      },
      INR: {
        monthly: 24999,
        yearly: 269988,
      },
    },
    update: "5 seconds",
    icon: FaCrown,
    color: "danger",
    gradient: "linear-gradient(135deg, #dc3545 0%, #c82333 100%)",
    cashfree_plan_id: {
      USD: {
        monthly: "ibr_ultimate_usd_m",
        yearly: "ibr_ultimate_usd_y",
      },
      INR: {
        monthly: "ibr_ultimate_inr_m_gst",
        yearly: "ibr_ultimate_inr_y_gst",
      },
    },
    features: [
      { text: "From 1.5 Cr API Requests/month (configurable)", icon: FaInfinity },
      { text: "Real-time Updates", icon: FaBolt },
      { text: "All Currency Pairs", icon: FaGem },
      { text: "Technical Indicators Access", icon: FaChartLine },
      { text: "Historical Data Access", icon: FaDatabase },
      { text: "All APIs Available", icon: FaCheckCircle },
      { text: "Priority Support", icon: FaShieldAlt },
    ],
    limitations: [],
    highlight: true,
    unlimited: false,
    popular: false,
    apiLimit: 15000000,
  },
];

// Plan comparison data
export const planComparison = {
  features: [
    {
      name: "API Requests per Month",
      free: "100",
      basic: "35,000 – 5,00,000",
      essential: "15,00,000 – 30,00,000",
      pro: "35,00,000 – 1 Cr",
      ultimate: "1.5 Cr – 3 Cr",
    },
    {
      name: "Update Frequency",
      free: "60 seconds",
      basic: "60 seconds",
      essential: "60 seconds",
      pro: "5 seconds",
      ultimate: "5 seconds",
    },
    {
      name: "Currency Pairs & Metals",
      free: "Basic",
      basic: "All",
      essential: "All",
      pro: "All",
      ultimate: "All",
    },
    {
      name: "Previous Close / Aggregate",
      free: "❌",
      basic: "✅",
      essential: "✅",
      pro: "✅",
      ultimate: "✅",
    },
    {
      name: "Reference Rates & DXY",
      free: "❌",
      basic: "❌",
      essential: "✅",
      pro: "✅",
      ultimate: "✅",
    },
    {
      name: "Technical Indicators",
      free: "❌",
      basic: "❌",
      essential: "❌",
      pro: "❌",
      ultimate: "✅",
    },
    {
      name: "60 Second Data Updates",
      free: "✅",
      basic: "✅",
      essential: "✅",
      pro: "❌",
      ultimate: "❌",
    },
    {
      name: "Real-Time Data Updates",
      free: "❌",
      basic: "❌",
      essential: "❌",
      pro: "✅",
      ultimate: "✅",
    },
    {
      name: "Support Level",
      free: "Community",
      basic: "Email",
      essential: "Email + Chat",
      pro: "Priority",
      ultimate: "Dedicated",
    },
  ],
};

// Helper function to get plan by backend name
export const getPlanByBackendName = (backendName) => {
  return plans.find((plan) => plan.backendName === backendName);
};

export const getCashfreePlanId = (backendName, currency, billingCycle) => {
  const plan = getPlanByBackendName(backendName);
  return plan?.cashfree_plan_id?.[currency]?.[billingCycle] || null;
};

// Helper function to get plan price based on currency and billing cycle
export const getPlanPrice = (plan, currency, billingCycle) => {
  if (!plan.pricing || !plan.pricing[currency]) return 0;
  return plan.pricing[currency][billingCycle] || 0;
};

// Helper function to format price
export const formatPrice = (price, currency) => {
  if (price === 0) return "Free";
  if (typeof price === "string") return price;

  if (currency === "USD") {
    return `$${price.toLocaleString()}`;
  } else if (currency === "INR") {
    return `₹${price.toLocaleString()}`;
  }

  return `${price.toLocaleString()} ${currency}`;
};
